/**
 * Created by rickborst on 02/08/2017.
 */

class PaymentDetails {

    /**
     * Constructs the object.
     *
     * @param {Object} data - Data object.
     */
    constructor (data = {}) {
        this.type = data.type || '';
        this.renewable = data.renewable || false;
        this.endDate = data.endDate || null;
        this.method = data.method || '';
        this.lastDigits = data.lastDigits || '';
        this.subscriptionId = data.subscriptionId || null;
        this.paymentGatewayId = data.paymentGatewayId || null;
        this.subscriptionName = data.subscriptionName || null;
        this.tmp = data.tmp || null;
        this.isNeedHideCardSection = data.isNeedHideCardSection || null;
    }
}

export default PaymentDetails;


// WEBPACK FOOTER //
// ./src/js/models/paymentdetails.js